<template>
   <v-card flat>
    <v-card-title>Postcodes</v-card-title>
    <hr/>
    <v-card-text v-html="text2"></v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    text2:
      " Postcodes endpoints are activated after entering “bearer ”+ token value of Login function into the api_key textbox in swagger <br/> OR <br/>While sending request we need to add header “Authorization” and set a value = “bearer ”+ token."
  })
};
</script>
